import { addDays, format } from 'date-fns';
import React from 'react';
import { CurrencyInput, Field, Toggle } from 'ui';
import RequiredStar from '~/components/ListFlow/RequiredStar';
import {
  changePricing,
  changedAuctionStartDate,
  getListFlowPricing,
  toggleAuction,
} from '~/store/listFlow/slices/pricing';
import { useAppDispatch, useAppSelector } from '~/store/store';

function formattedDate(date: Date) {
  return format(date, "yyyy-MM-dd'T'HH:mm");
}

interface Props {}

const ListFlowAuctionRow: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const pricing = useAppSelector(getListFlowPricing);

  return (
    <div className="mt-4">
      <label className="mb-2 flex justify-between">
        <span>
          <span className="block text-sm font-semibold">Auction Item</span>
          <span className="text-slate-green-500 text-xs">
            All auctions last 7 days. The highest offer will automatically be
            accepted when the auction ends.
          </span>
        </span>
        <Toggle
          onChange={enabled => dispatch(toggleAuction({ enabled }))}
          value={pricing.isAuction || false}
        />
      </label>

      {pricing.isAuction && (
        <div className="grid grid-cols-2 gap-4">
          <Field
            label={
              <span>
                Confirm Starting Price <RequiredStar />
              </span>
            }
            id="confirm-auction-start-price"
          >
            <CurrencyInput
              id="confirm-auction-start-price"
              onChange={value =>
                dispatch(changePricing({ field: 'listPrice', value }))
              }
              value={pricing.listPrice}
            />
          </Field>

          <Field
            label={
              <span>
                Start Date <RequiredStar />
              </span>
            }
            id="confirm-auction-start-date"
            type="datetime-local"
            min={formattedDate(new Date())}
            max={formattedDate(addDays(new Date(), 30))}
            value={
              pricing.auctionStartDate
                ? formattedDate(new Date(pricing.auctionStartDate))
                : ''
            }
            onChange={e =>
              dispatch(
                changedAuctionStartDate({
                  newDate: e.target.value
                    ? new Date(e.target.value).toISOString()
                    : null,
                }),
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default ListFlowAuctionRow;
